import { FORM_BUILDER_FIELD_TYPE, formBuilderMapper, ButtonSizeOptions } from "@loanbossinc/component-library";
// import {peopleGetContactsByCompany} from '../propertyDetail.store';

export const rows = isLoading => ({
  title: {
    label: "Company Owners",
    isTitle: true
  },
  owners: {
    hasNestedRows: true,
    key: "companyOwners",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.NESTED,
        Cell: formBuilderMapper,
        style: { width: "100%" },
        subComponents: [
          {
            map: index => ({
              type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
              key: "principleOwnerId",
              name: `companyOwners[${index}].principleOwnerId`,
              componentorder: 0,
              collectionname: "companyOwners",
              variant: "filled",
              displayWith: option => option.name,
              setValueWith: option => option.id
            })
          },
          {
            map: index => ({
              type: FORM_BUILDER_FIELD_TYPE.BUTTON,
              label: "Remove Owner",
              size: ButtonSizeOptions.lgFluid,
              disabled: isLoading,
              name: `companyOwners[${index}].id`,
              style: { width: "214px", marginTop: "10px", float: "right", border: "none" },
              onClick: (value, formik) => {
                if (value) {
                  let companyOwners = formik.values.companyOwners;
                  companyOwners = companyOwners.filter(companyOwners => companyOwners.id !== value);
                  formik.setValues({ ...formik.values, companyOwners });
                }
              }
            })
          }
        ]
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.NESTED,
        Cell: formBuilderMapper,
        subComponents: [
          {
            map: index => ({
              type: FORM_BUILDER_FIELD_TYPE.PERCENT,
              label: "Ownership Percentage",
              name: `companyOwners[${index}].ownershipPercentage`,
              variant: "filled",
              decimals: 2,
              style: { marginTop: "10px", marginLeft: "0" }
            })
          }
        ]
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.NESTED,
        Cell: formBuilderMapper,
        subComponents: [
          {
            map: index => ({
              type: FORM_BUILDER_FIELD_TYPE.SWITCH,
              label: "External Equity",
              altlabel: "Internal Equity",
              name: `companyOwners[${index}].isExternalEquitySource`
            })
          }
        ]
      }
    ]
  },
  addRecord: {
    key: "addRecord",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TEXT,
        value: "Add a new company owner"
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.BUTTON,
        label: "Add",
        hideLabel: true,
        disabled: isLoading,
        size: ButtonSizeOptions.sm,
        onClick: (value, formik) => {
          const companyOwners = formik.values.companyOwners;
          companyOwners.splice(formik.values.companyOwners.length, 0, { propertyId: formik.values.id, principleOwnerId: null, isExternalEquitySource: false, ownershipPercentage: 1, principleType: "company" });
          formik.setValues({ ...formik.values, companyOwners });
        },
        style: { width: "132px", marginTop: "10px", float: "right" }
      }
    ]
  }
});
